const tab_sections = {
    overview: '概要',
    authentication: '認証',
    authorization: '認可',
    users: 'ユーザー',
    developer: '開発者',
    tenant: 'テナント',
};
export default Object.freeze(tab_sections);
